// extracted by mini-css-extract-plugin
module.exports = {"collapseContainer":"Card_collapseContainer__2P281","card":"Card_card__TMpHf","cardName":"Card_cardName__2Ewh3","configurableForm":"Card_configurableForm__aodrY"};